import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6489e46a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "dropdown",
  ref: "dropdownRef"
}
const _hoisted_2 = {
  key: 0,
  class: "dropdown-menu",
  ref: "dropdownMenu"
}
const _hoisted_3 = ["disabled", "onClick"]
const _hoisted_4 = { class: "dropdown-menu__title" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "dropdown-menu__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleOptions && _ctx.toggleOptions(...args)), ["prevent"])),
      class: _normalizeClass(["header__options", { open: _ctx.showOptions }]),
      ref: "dropdownButton"
    }, [
      _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
      _createElementVNode("span", {
        class: _normalizeClass(["dropdown-arrow", { open: _ctx.showOptions }])
      }, null, 2)
    ], 2),
    (_ctx.showOptions)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("button", {
                disabled: item.disabled,
                onClick: ($event: any) => (_ctx.handleClick(item)),
                class: "dropdown-menu__item"
              }, [
                _createElementVNode("span", _hoisted_4, [
                  (item.icon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: item.icon,
                        alt: "",
                        class: "dropdown-icon"
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(item.label), 1)
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(item.description), 1)
              ], 8, _hoisted_3)
            ]))
          }), 128))
        ], 512))
      : _createCommentVNode("", true)
  ], 512))
}